<template>
    <div class="container-fluid" style="margin-top: 5%;">
        <v-row justify="center">
            <v-col class="py-0">
                <v-row class="py-0">
                    <v-col class="pl-3">
                        <v-row>
                            <v-col class="py-0" style="line-height: 20px; padding: 0% 5% 0% 5%;">
                                <p class="text-center text-h5">
                                    {{$t("unPaidRegistration.canceledRegistration.title")}} 
                                </p>
                                <p class="text-center">
                                    <i class="fab fa-paypal fa-spin " style="width: 30px; height: 30px;"></i> <br /><br />
                                    {{$t("unPaidRegistration.canceledRegistration.text")}} 
                                </p>
                                <v-row>
                                    <v-col style="display: flex">
                                       <v-btn :color="`${buttonColor}`" @click="routeLink('RegisterEventLegacy')" style="margin: 1rem 1rem 0 auto">{{ $t("unPaidRegistration.canceledRegistration.register-again")}}</v-btn>
                                       <v-btn @click="routeLink('Profile')" style="margin: 1rem auto 0 0">{{ $t("unPaidRegistration.canceledRegistration.back-profile")}}</v-btn> 
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import RegistrationService from '@/services/RegistrationService';
import AuthService from '@/services/AuthService';
import { VRow, VCol, VBtn } from 'vuetify/lib';
import LocalStorageService from '../services/LocalStorageService';
import PaymentService from "@/services/PaymentService";

export default {
    components:{
       VRow, VCol, VBtn
    },
    data() {
        return {
            event: null,
            userId: null,
            buttonColor: null,
            response: null,
            isError: false,
            promoterName: null
        };
    },
    methods: {
        cleanLocalStorage() {
            LocalStorageService.removeItem("registrationType");
            LocalStorageService.removeItem("summary");
            LocalStorageService.removeItem("regId");
            LocalStorageService.removeItem("registration");
            LocalStorageService.removeItem("organizations");
        },
        routeLink(name) {
            this.$router.push({ name });
        }
    },
    async created() {
        this.eventId = this.$route.query.eId;
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
        await AuthService.getUserCurrent().then(async (response) => {
            if(response.data.success == 1){
                this.userId = response.data.message.id;
                const _response = await RegistrationService.getCanceledRegistration({eventId: this.eventId, userId: this.userId});
                /*let imgUser = response.data.message.existFile 
                    ? this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+"/laravel/public"+response.data.message.image 
                    : require("@/assets/images/partPlaceholder.jpg")
                    ? this.$store.getters.env.get('VUE_APP_DEV_API_HOST') + response.data.message.image
                    : require("@/assets/images/partPlaceholder.jpg");
                this.$emit("imageUser", imgUser);*/
                if(_response.data.success) {
                    this.cleanLocalStorage();
                    await PaymentService.hasUnpaidRegistrations().then(response =>{
                        if(response.data.success == 1){
                            this.hasUnpaidRegistrations = response.data.message;
                            this.$store.dispatch('setUnPaidRegistrationAction', this.hasUnpaidRegistrations);
                        }else{
                            this.$store.dispatch('setUnPaidRegistrationAction', false);
                        }
                    });
                }
            }
        })
    },
    async mounted() {}  
}
</script>

<style scoped>
.bg_row {
    background-image: url(/participant/img/BackGroundImage.c515e0cf.png);
    background-size: contain !important;
    background-repeat: no-repeat !important;
    padding-top: 70px;
    padding-bottom: 70px;
}
.bg_row p {
    margin-bottom: 10px;
}
</style>